// import { IEmailExists } from 'modules/authModule/types/emailValidType'
// import { IPasswordChange } from 'modules/authModule/types/passwordChangeType'
const groupPrefix = 'auth'

export const apiAuth = {
	login: async (login: string, password: string) => {
		const obj = { login, password }
		const data = await apiCommon<IUser>(`${groupPrefix}/login`, { method: 'POST', body: userToJSON(obj) })
		return data
	},

	register: async (email: string, password: string, phoneNumber: string, name: string, lastName: string, consents: IUserConsentsModel) => {
		const obj = {
			email,
			password,
			phone_number: phoneNumber,
			name,
			last_name: lastName,
			consents,
		}
		const body = await useRecaptchaService().withToken(userToJSON(obj), 'register')
		const data = await apiCommon<IUser>(`${groupPrefix}/register`, { method: 'POST', body })
		return data
	},

	loginByCode: async (code: string) => {
		const { data } = await apiCommon<IUser>(`${groupPrefix}/exchange-code`, { method: 'POST', body: { code } })
		return data
	},

	verifyEmail: async (userID: string, hash: string, params?: { expires?: string; signature?: string }) => {
		const query = new URLSearchParams()
		if (params?.expires) query.append('expires', params.expires)
		if (params?.signature) query.append('signature', params.signature)
		const queryString = query.toString()

		await apiCommon(`${groupPrefix}/email/verify/${userID}/${hash}${queryString ? `?${queryString}` : ''}`, { method: 'GET' })
	},

	resendEmailVerification: async () => {
		await apiCommon(`${groupPrefix}/email/verify/resend`, { method: 'POST' })
	},

	setCookies: async () => {
		await apiCommon('sanctum/csrf-cookie', { method: 'GET' })
	},

	logout: async () => {
		await apiCommon(`${groupPrefix}/logout`, { method: 'POST' })
	},

	fetchUser: async () => {
		const { data } = await apiCommon<IUser>(`${groupPrefix}/me`, { method: 'GET' })
		return User(data)
	},

	adminLogin: async (login: string, password: string) => {
		const obj = { login, password }
		const data = await apiCommon<IUser>(`${groupPrefix}/admin/login`, { method: 'POST', body: userToJSON(obj) })
		return data
	},

	adminLogout: async () => {
		await apiCommon(`${groupPrefix}/admin/logout`, { method: 'POST' })
	},

	adminFetchUser: async () => {
		const { data } = await apiCommon<IUser>(`${groupPrefix}/admin/me`, { method: 'GET' })
		return User(data)
	},

	updateUser: async (user: Partial<IUserModel>) => {
		const { data } = await apiCommon<IUser>('profile', { method: 'PATCH', body: userToJSON(user) })
		return User(data)
	},

	forgotPassword: async (email: string) => {
		const data = await apiCommon('auth/reset-password/send-email', { method: 'POST', body: { email } })
		return data
	},

	changePassword: async (token: string, email: string, password: string, passwordConfirmation: string) => {
		const obj = { token, email, password, passwordConfirmation }
		const data = await apiCommon<IPasswordChange>('auth/reset-password/validate', { method: 'POST', body: changePasswordToJSON(obj) })
		return data
	},

	updatePassword: async (currentPassword: string, password: string, passwordConfirmation: string) => {
		const data = await apiCommon(`${groupPrefix}/password`, {
			method: 'PUT',
			body: {
				current_password: currentPassword,
				password,
				password_confirmation: passwordConfirmation,
			},
		})
		return data
	},

	resendEmail: async () => {
		const data = await apiCommon(`${groupPrefix}/verification-email/resend`, { method: 'GET' })
		return data
	},

	loginBD: async (email: string, password: string) => {
		const obj = { email, password }
		const { data } = await apiCommon<IUser>(`${groupPrefix}/login-bd`, { method: 'POST', body: userToJSON(obj) })
		return User(data)
	},

	invokeLoginPhoneCode: async (phoneNumber: any) => {
		const { data } = await apiCommon<{ data: any }>(`${groupPrefix}/login-phone`, {
			method: 'POST',
			body: await useRecaptchaService().withToken(userLoginToJSON({ phoneNumber }), 'login_phone'),
		})
		return data
	},

	confirmLoginPhoneCode: async (phoneNumber: any, code: any) => {
		const { data } = await apiCommon<{ data: any }>(`${groupPrefix}/login-phone/confirm`, {
			method: 'POST',
			body: userLoginToJSON({ phoneNumber, code }),
		})
		return data
	},
	confirmRegisterPhoneCode: async (
		email: string,
		password: string,
		phoneNumber: string,
		name: string,
		lastName: string,
		code: string,
		consents: IUserConsentsModel,
	) => {
		const obj: IUserRegisterModel = {
			email,
			password,
			phoneNumber,
			name,
			lastName,
			code,
			consents,
		}
		const data = await apiCommon<{ data: any }>(`${groupPrefix}/register/confirm`, {
			method: 'POST',
			body: userRegisterToJSON(obj),
		})
		return data
	},

	checkExistingEmail: async (email: string) => {
		const { data } = await apiCommon<{ data: string }>(`${groupPrefix}/check-email`, {
			method: 'POST',
			body: { email },
		})
		return data
	},

	checkExistingPhone: async (phone: string) => {
		const { data } = await apiCommon<{ data: string }>(`${groupPrefix}/check-phone`, {
			method: 'POST',
			body: { phone_number: phone },
		})
		return data
	},

	addPhoneNumber: async (phoneNumber: string) => {
		const data = await apiCommon(`${groupPrefix}/phone-number/add`, {
			method: 'POST',
			body: await useRecaptchaService().withToken({ phone_number: phoneNumber }, 'phone_number_add'),
		})
		return data
	},

	confirmPhoneNumber: async (code: string) => {
		const data = await apiCommon(`${groupPrefix}/phone-number/confirm`, {
			method: 'POST',
			body: { code },
		})
		return data
	},
}
